export default "__VITE_ASSET__Cbwgvoe___"